import { render, staticRenderFns } from "./ULoginHeader.vue?vue&type=template&id=8e39b294&scoped=true&"
import script from "./ULoginHeader.vue?vue&type=script&lang=ts&"
export * from "./ULoginHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ULoginHeader.vue?vue&type=style&index=0&id=8e39b294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e39b294",
  null
  
)

export default component.exports